<template>

	<div>
		<div style="color: #3e3e3e;font-size: 18px;margin-bottom: 15px;">充值卡金列表</div>
		<div class="title1">
			<div class="right">
				<div>
					<el-button type="primary" size="small" @click="adddeposit()">新增卡金套餐</el-button>
				</div>
			</div>
		</div>
		<div style="margin-top:15px">
			<el-table :data="depositList" style="width: 100%"
				:header-cell-style="{background:'#F2F2F4','text-align':'center'}">
				<el-table-column prop="id" align="center" label="ID"></el-table-column>
				<el-table-column prop="name" align="center" label="套餐名称" width="200"></el-table-column>
				<el-table-column align="center" label="充值金额">
					<template slot-scope="scope">
						{{ (scope.row.getTotal/100).toFixed(2) }}
					</template>
				</el-table-column>
				<el-table-column label="赠送内容" prop="sendType" align="center" width="200"></el-table-column>
				<el-table-column align="center" label="价格">
					<template slot-scope="scope">
						{{ (scope.row.price/100).toFixed(2) }}
					</template>
				</el-table-column>
				<el-table-column prop="addTime" align="center" label="创建时间"></el-table-column>
				<el-table-column prop="orderBy" align="center" label="排序"></el-table-column>
				<el-table-column label="操作">
					<template slot-scope="{row}">
						<el-button type="text" @click="adddeposit(row.id-1)">编辑</el-button>
						<el-button type="text" @click="updown(row, row.status==0?1:0)" :class="row.status==0?'':'red'">
							{{row.status==0?"上架":"下架"}}
						</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="turnwai">
			<div class="turn">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page="filter.pageNum" :page-sizes="[10,15,20,30]" :page-size="filter.pageSize"
					layout="total, sizes, prev, pager, next, jumper" :total="filter.total">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				total: 0,
				filter: {
					pageNum: 1, // 页码
					pageSize: 20, // 条数
					name: "", // 套餐名称
					status: "", // 0上架 1下架
					overdue: 0,
					total: 0,
				},
				// name: "",//套餐名称
				// getTotal: "",//充值金额
				// sendType: "",//赠送内容
				// price: "",//购买价格
				// addTime: "",//创建时间
				// orderBy: "",//排序
				// status: "",//状态
				depositList: [],
				dialog_tuig: false,
				dialog_user: false,
				cjurl: "https://lanhu.oss-cn-beijing.aliyuncs.com/ps1eb15cb7c10e81b9-5a84-438d-b0da-0865ed2f6393",
				img: 'https://lanhu.oss-cn-beijing.aliyuncs.com/ps1eb15cb7c10e81b9-5a84-438d-b0da-0865ed2f6393',
			}
		},
		mounted() {
			this.getdepositlist()
		},
		watch: {
			filter: { //深度监听，可监听到对象、数组的变化
				handler(val, oldVal) {
					this.getdepositlist()
				},
				deep: true
			}
		},
		methods: {
			// 上架下架
			updown(row, status) {
				let data = {
					id: row.id,
					status: status,
				}
				this.$http.post("dCharge/save", JSON.stringify(data)).then(res => {
					if (res.body.code != 200) {
						this.$message.error(res.body.msg);
					} else {
						this.getdepositlist()
						this.$message.success("上架/下架成功！");
					}
				})
			},
			//新建、编辑
			adddeposit(id) {
				if (id) {
					this.$router.push({
						path: "/newdeposit",
						query: {
							id: id
						}
					})
				} else {
					this.$router.push({
						path: "/newdeposit"
					})
				}
			},
			//获取
			getdepositlist() {
				this.$http.get("dCharge/list").then(function(res) {
					if (res.body.code == 200) {
						this.depositList = res.body.data
						this.filter.total = res.body.total
					}
				}, function(err) {
					this.$message.error("请求失败")
				})
			},
			handleSizeChange(val) {
				this.filter.pageSize = val
				this.getdepositlist()
			},
			handleCurrentChange(val) {
				this.filter.pageNum = val
				this.getdepositlist()
			}
		}
	}
</script>

<style lang="less" scoped>
	p {
		padding: 0;
		margin: 0;
	}

	.red {
		color: red;
	}

	.title1 {
		width: 100%;

		.left {
			float: left;
		}

		.right {
			float: right;
		}

		&::after {
			content: "";
			width: 1px;
			display: block;
			clear: both;
		}
	}

	.tanchutitle {
		margin-top: -30px;
		width: 100%;
		height: 42px;
		line-height: 42px;
		background-color: #F2F2F2;
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #888888;
		box-sizing: border-box;
		padding-left: 10px;

	}

	.title {
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3E3E3E;
		display: flex;
		font-weight: bold;
		margin-bottom: 10px;

		.blue {
			width: 5px;
			height: 15px;
			background: #409EFF;
			border-radius: 2px;
			margin-right: 8px;
			position: relative;
			top: 4px;
		}
	}

	.erwei {
		width: 157px;
		height: 157px;
		margin: 20px auto;

		img {
			width: 100%;
			height: 100%;
		}
	}

	.downerwei {
		cursor: pointer;
		width: 100%;
		text-align: center;
		font-size: 18px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #409EFF;
	}

	.dialog-footer {
		margin-top: -10px;
		margin-bottom: 20px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}

	.first_line {
		margin: 20px 0;
		display: flex;
		justify-content: space-between;

		.right_warp {
			display: flex;
			align-items: center;
			font-size: 16px;
			color: #3e3e3e;

			.el-select {
				width: 120px;
			}

			.el-input {
				width: 180px;
			}

			.jul {
				margin-left: 10px;
			}
		}
	}

	.pagescg {
		margin-top: 20px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}

	// 
	.boton {
		display: flex;

		>div {
			margin-right: 15px;
			flex-wrap: wrap;

			.boton1_title {
				cursor: pointer;
				height: 32px;
				padding-left: 8px;
				padding-right: 8px;
				border: 1px dashed #D9DCE3;
				border-radius: 4px;
				font-size: 14px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #959595;
				line-height: 32px;
				text-align: center;
			}

			.botonlist {
				margin-top: 15px;
				text-align: center;
				line-height: 32px;
				font-size: 14px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #959595;
				width: 99px;
				height: 32px;
				border: 1px solid #D9DCE3;
				border-radius: 4px;
				position: relative;

				div {
					cursor: pointer;
					line-height: 15px;
					position: absolute;
					width: 16px;
					height: 16px;
					background-color: black;
					color: white;
					border-radius: 50%;
					font-size: 14px;
					right: -8px;
					top: -8px;
				}
			}
		}

	}

	.bon_data {
		display: flex;

		div {
			padding-left: 5px;
			padding-right: 5px;
		}
	}

	.lastbottom {
		width: 138px;
		margin-left: 29%;
		margin-top: 25px;
	}

	.duo {
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #959595;
		opacity: 0.51;
		margin-top: -4px;
	}

	.lastdig {
		/deep/.el-dialog__close {
			display: none;
		}

		.mybotton {
			margin-left: 39%;
			margin-top: 15px;
		}
	}

	.turnwai {
		margin-top: 20px;
		width: 100%;
		height: 25px;
	}

	.turn {
		margin-left: 15%;
	}
</style>